(() => {
  const script = document.currentScript;
  const mobile = matchMedia('(min-width:0px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  customElements.whenDefined('sticky-header').then(() => {
    const sticky = document.querySelector('sticky-header');
    const header = sticky?.header;
    if (!header || header.dataset.monsterNav) return;
    header.dataset.monsterNav = 'ready';
    const hand = document.createElement('div');
    const handImage = new Image();
    handImage.alt = '';
    const armColumn = document.createElement('div');
    armColumn.className = 'vd-monster-arm-column';
    armColumn.append(handImage);
    hand.append(armColumn);
    hand.className = 'vd-monster-hand';
    hand.setAttribute('aria-hidden', 'true');
    header.append(hand);
    const nativeScroll = sticky.onScrollHandler;
    let last = Math.max(0, scrollY), distance = 0, direction = 0, state = 'visible';
    let headerAnimation, handAnimation, generation = 0;
    const blocked = () => (innerWidth >= 990 && header.matches(':hover')) || !!header.querySelector('details[open]') || sticky.predictiveSearch?.isOpen || header.contains(document.activeElement) && document.activeElement !== document.body;
    const stop = () => {
      generation++;
      headerAnimation?.cancel();
      handAnimation?.cancel();
      hand.style.visibility = 'hidden';
      hand.style.opacity = '0';
      header.inert = false;
    };
    const show = (immediate = false) => {
      if (state === 'visible' && !immediate) return;
      const from = getComputedStyle(header).transform;
      stop();
      state = 'visible';
      header.style.removeProperty('transform');
      header.classList.remove('shopify-section-header-hidden', 'animate');
      if (!immediate && !reduced.matches) headerAnimation = header.animate([{transform:from},{transform:'translateY(0)'}], {duration:360,easing:'ease-out'});
    };
    const hide = () => {
      if (state !== 'visible' || blocked()) return;
      state = 'lifting';
      const token = ++generation;
      const lift = header.getBoundingClientRect().height + 110;
      const target = `translateY(-${lift}px)`;
      const duration = reduced.matches || !handImage.complete || !handImage.naturalWidth ? 0 : 2400;
      if (duration) {
        hand.style.visibility = 'visible';
        hand.style.opacity = '1';
        handAnimation = hand.animate([
          {transform:`translateY(-${lift}px) rotate(0)`,offset:0},
          {transform:'translateY(0) rotate(0)',offset:0.28},
          {transform:'translateY(0) rotate(0) scale(1.04)',offset:0.44},
          {transform:'translateY(0) rotate(0) scale(1.04)',offset:1}
        ],{duration,fill:'forwards',easing:'ease-in-out'});
      }
      headerAnimation = header.animate([
        {transform:'translateY(0)',offset:0},
        {transform:'translateY(0)',offset:0.44},
        {transform:target,offset:1}
      ],{duration,fill:'forwards',easing:'cubic-bezier(.45,0,.3,1)'});
      headerAnimation.finished.then(() => {
        if (generation !== token) return;
        state = 'hidden';
        header.style.transform = target;
        header.inert = true;
        headerAnimation.cancel();
        handAnimation?.cancel();
        hand.style.visibility = 'hidden';
        hand.style.opacity = '0';
      }).catch(() => {});
    };
    const configure = () => {
      show(true);
      header.classList.toggle('vd-monster-nav-enabled', mobile.matches);
      if (mobile.matches && !handImage.src) handImage.src = new URL('vd-monster-arm-20261014.webp', script.src).href;
      distance = 0;
      last = Math.max(0, scrollY);
    };
    window.removeEventListener('scroll', nativeScroll);
    window.addEventListener('scroll', () => {
      if (!mobile.matches) { nativeScroll(); return; }
      const y = Math.max(0, scrollY), delta = y - last;
      last = y;
      if (y <= 4 || blocked()) { show(true); distance = 0; return; }
      if (Math.abs(delta) < 2) return;
      const next = Math.sign(delta);
      distance = next === direction ? distance + Math.abs(delta) : Math.abs(delta);
      direction = next;
      if (next < 0 && distance >= 10) show();
      if (next > 0 && y > 32 && distance >= 24) hide();
    }, {passive:true});
    header.addEventListener('focusin', () => show(true));
    document.addEventListener('visibilitychange', () => { if (document.hidden) show(true); });
    mobile.addEventListener('change', configure);
    reduced.addEventListener('change', configure);
    configure();
  });
})();
